import { apiFetch } from "@/api/client";

export interface SessionSummary {
  acctuniqueid: string;
  username: string | null;
  nasipaddress: string;
  calledstationid: string | null;
  callingstationid: string | null;
  framedipaddress: string | null;
  acctstarttime: string | null;
  acctsessiontime: number | null;
  acctinputoctets: number | null;
  acctoutputoctets: number | null;
  is_active: boolean;
}

export interface SessionListResponse {
  items: SessionSummary[];
  total: number;
  page: number;
  page_size: number;
}

export interface UsageTimeResponse {
  username: string;
  total_seconds: number;
  session_count: number;
}

export interface DeviceHistoryEntry {
  callingstationid: string;
  first_seen: string | null;
  last_seen: string | null;
  session_count: number;
}

export interface IpHistoryEntry {
  framedipaddress: string;
  first_seen: string | null;
  last_seen: string | null;
  session_count: number;
}

export interface DisconnectResult {
  acctuniqueid: string;
  sent: boolean;
  detail: string;
}

export const listActiveSessions = (page: number) =>
  apiFetch<SessionListResponse>(`/sessions/active?page=${page}&page_size=25`);

export const listSessionHistory = (username: string, page: number) =>
  apiFetch<SessionListResponse>(
    `/sessions/history?page=${page}&page_size=25${username ? `&username=${encodeURIComponent(username)}` : ""}`,
  );

export const disconnectSession = (acctuniqueid: string) =>
  apiFetch<DisconnectResult>(`/sessions/${encodeURIComponent(acctuniqueid)}/disconnect`, {
    method: "POST",
    body: JSON.stringify({ confirm: true }),
  });

export const fetchUsageTime = (username: string) =>
  apiFetch<UsageTimeResponse>(`/users/${encodeURIComponent(username)}/usage-time`);

export const fetchDeviceHistory = (username: string) =>
  apiFetch<DeviceHistoryEntry[]>(`/users/${encodeURIComponent(username)}/devices`);

export const fetchIpHistory = (username: string) =>
  apiFetch<IpHistoryEntry[]>(`/users/${encodeURIComponent(username)}/ip-history`);
